import React, { lazy, Suspense } from "react"; // Import necessary modules
import { Route, Switch } from "react-router-dom"; // Import routing components
import Loader from "./Components/Loader"; // Import Loader component for showing a loading state

// Lazily load components to improve performance by splitting code into chunks
const Adminpage = lazy(() => import("./Components/AdminPage/Adminpage"));
const Landingpage = lazy(() => import("./Components/AdminPage/LandingPage/Landingpage"))
const AdminPage = lazy(() => import("./Components/AdvancedAuction/AdminPage/AdminPage"));
const AdvancedAuction = lazy(() => import("./Components/AdvancedAuction/AdvancedAuction"));
const CreateAuction = lazy(() => import("./Components/AdvancedAuction/CreateAuction"));
const HistoryPage = lazy(() => import("./Components/AdvancedAuction/History/History"));
const AnalyzeNowNew = lazy(() => import("./Components/AnalyzeNowNew/AnalyzeNowNew"));
const Auction = lazy(() => import("./Components/Auction/Auction"));
const History = lazy(() => import("./Components/Auction/History/History"));
const AuctionConfiguration = lazy(() => import("./Components/AuctionConfiguration/AuctionConfiguration"));
// const AuctionShortlist = lazy(() => import("./Components/AuctionShortlist/AuctionShortlist"));
const Company = lazy(() => import("./Components/CompanySelect"));
const Documents = lazy(() => import("./Components/Documents"));
const NewLanesPage = lazy(() => import("./Components/Lanes/NewLanesPage"));
const Notifications = lazy(() => import("./Components/Notifications"));
const RateCards = lazy(() => import("./Components/RateCards"));
const Schedule = lazy(() => import("./Components/Schedule"));
const Shortlist = lazy(() => import("./Components/Shortlist"));
const Unauthorized = lazy(() => import("./Components/Unauthorized/Unauthorized"));
// const UploadsByLSP = lazy(() => import("./Components/UploadsByLSP"));
const UploadsList = lazy(() => import("./Components/UploadsList"));
const NewProcurementLsps = lazy(() => import('./Components/NewProcurementLsps/NewProcurementLsps'));

// RouterOutlet component for rendering routes based on props
const RouterOutlet = ({ onlyAuction, onlyProcurement, both, show }) => {
  return (
    <Suspense fallback={<Loader show={true} />}> {/* Show Loader while components are being loaded */}
      {show ? (
        <Loader show={show} /> // Show Loader if 'show' prop is true
      ) : both ? (
        <Switch>
          {/* Define routes for all pages when 'both' prop is true */}
          <Route path="/" exact component={Company} />
          <Route path="/shortlist" exact component={Shortlist} />
          <Route path="/shortlist/:id" exact component={Shortlist} />
          <Route path="/lanes" exact component={NewLanesPage} />
          <Route path="/lanes/:id" exact component={NewLanesPage} />
          <Route path="/company" exact component={Company} />
          <Route path="/schedule" exact component={Schedule} />
          <Route path="/notifications" exact component={Notifications} />
          <Route path="/schedule/:id" exact component={Schedule} />
          <Route path="/notifications/:id" exact component={Notifications} />
          {/* <Route path="/uploadsbylsp" exact component={UploadsByLSP} /> */}
          {/* <Route path="/uploadsbylsp/:id" exact component={UploadsByLSP} /> */}
          <Route path="/uploads" exact component={UploadsList} />
          <Route path="/uploads/:id" exact component={UploadsList} />
          <Route path="/documents" exact component={Documents} />
          <Route path="/documents/:id" exact component={Documents} />
          <Route path="/AnalyzeNow" exact component={AnalyzeNowNew} />
          <Route path="/AnalyzeNow/:id" exact component={AnalyzeNowNew} />
          <Route path="/rate-cards" exact component={RateCards} />
          <Route path="/rate-cards/:id" exact component={RateCards} />
          <Route path="/lsps" exact component={NewProcurementLsps} />
          <Route path="/lsps/:id" exact component={NewProcurementLsps} />
          <Route path="/admin" exact component={Landingpage} />
          <Route path="/adminconsole/:id" exact component={Adminpage} />
          <Route path="/history/:id" exact component={History} />
          <Route path="/auction" component={Auction} exact />
          <Route path="/auctionconfig" component={AuctionConfiguration} exact />
          {/* <Route path="/auctionShortlist" component={AuctionShortlist} exact /> */}
          <Route path="/unauthorized" exact component={Unauthorized} />
          <Route path="/lane_auction" component={AdvancedAuction} exact />
          <Route path="/auctionsconfig" component={CreateAuction} exact />
          <Route path="/laneadminconsole/:id" exact component={AdminPage} />
          <Route path="/lane_history/:id" exact component={HistoryPage} />
        </Switch>
      ) : onlyProcurement ? (
        <Switch>
          {/* Define routes for procurement-related pages when 'onlyProcurement' prop is true */}
          <Route path="/" exact component={Company} />
          <Route path="/shortlist" exact component={Shortlist} />
          <Route path="/shortlist/:id" exact component={Shortlist} />
          <Route path="/lanes" exact component={NewLanesPage} />
          <Route path="/lanes/:id" exact component={NewLanesPage} />
          <Route path="/company" exact component={Company} />
          <Route path="/schedule" exact component={Schedule} />
          <Route path="/notifications" exact component={Notifications} />
          <Route path="/schedule/:id" exact component={Schedule} />
          <Route path="/notifications/:id" exact component={Notifications} />
          {/* <Route path="/uploadsbylsp" exact component={UploadsByLSP} /> */}
          {/* <Route path="/uploadsbylsp/:id" exact component={UploadsByLSP} /> */}
          <Route path="/uploads" exact component={UploadsList} />
          <Route path="/uploads/:id" exact component={UploadsList} />
          <Route path="/documents" exact component={Documents} />
          <Route path="/documents/:id" exact component={Documents} />
          <Route path="/lsps" exact component={NewProcurementLsps} />
          <Route path="/lsps/:id" exact component={NewProcurementLsps} />
          <Route path="/analysisNow" exact component={AnalyzeNowNew} />
          <Route path="/analysisNow/:id" exact component={AnalyzeNowNew} />
          <Route path="/rate-cards" exact component={RateCards} />
          <Route path="/rate-cards/:id" exact component={RateCards} />
          <Route path="*" exact component={Unauthorized} />
        </Switch>
      ) : onlyAuction ? (
        <Switch>
          {/* Define routes for auction-related pages when 'onlyAuction' prop is true */}
          <Route path="/" exact component={Auction} />
          <Route path="/admin" exact component={Landingpage} />
          <Route path="/adminconsole/:id" exact component={Adminpage} />
          <Route path="/history/:id" exact component={History} />
          <Route path="/auction" component={Auction} exact />
          <Route path="/auctionconfig" component={AuctionConfiguration} exact />
          {/* <Route path="/auctionShortlist" component={AuctionShortlist} exact /> */}
          <Route path="/lane_auction" component={AdvancedAuction} exact />
          <Route path="/auctionsconfig" component={CreateAuction} exact />
          <Route path="/laneadminconsole/:id" exact component={AdminPage} />
          <Route path="/lane_history/:id" exact component={HistoryPage} />
          <Route path="*" exact component={Unauthorized} />
        </Switch>
      ) : (
        <Switch>
          {/* Default route when no props match */}
          <Route path="/" exact component={Unauthorized} />
        </Switch>
      )}
    </Suspense>
  );
};

export default RouterOutlet;
